import React from 'react';
import ReactDOM from 'react-dom';
import { AzureAD } from 'react-aad-msal';
import { authProvider } from './Auth/authProvider';

import './index.css';
import 'react-image-lightbox/style.css';
import 'draft-js/dist/Draft.css';
import './Styles/GlobalClasses.scss';
import * as serviceWorker from './serviceWorker';

import LoadingData from './Pages/LoadingData';

console.log(process.env.NODE_ENV)

ReactDOM.render(
  <AzureAD provider={authProvider} forceLogin={true}>
    {<LoadingData provider={authProvider} />}
  </AzureAD>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
